import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { API } from '@/utils/api';

const DAYS = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

export const WorkshopSettingsDialog = ({ open, onClose }) => {
  const [s, setS] = useState(null);
  useEffect(() => { if (open) axios.get(`${API}/agenda/workshop-settings`).then(r => setS(r.data)); }, [open]);
  const setRange = (d, i, j, v) => setS(x => { const h = { ...x.hours, [d]: x.hours[d].map((r, k) => (k === i ? (j === 0 ? [v, r[1]] : [r[0], v]) : r)) }; return { ...x, hours: h }; });
  const add = (d) => setS(x => ({ ...x, hours: { ...x.hours, [d]: [...(x.hours[d] || []), ['13:30', '17:30']] } }));
  const del = (d, i) => setS(x => ({ ...x, hours: { ...x.hours, [d]: x.hours[d].filter((_, k) => k !== i) } }));
  const save = async () => {
    try { await axios.put(`${API}/agenda/workshop-settings`, s); toast.success('Horaires enregistrés'); onClose(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Erreur'); }
  };
  return (
    <Dialog open={open} onOpenChange={v => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="workshop-settings-dialog">
        <DialogHeader><DialogTitle>Horaires d'ouverture et postes</DialogTitle></DialogHeader>
        {s && (
          <div className="space-y-3">
            <div className="flex items-center gap-3"><Label className="w-40">Postes (ponts) simultanés</Label>
              <Input type="number" min="1" max="20" className="w-20" value={s.bays} onChange={e => setS({ ...s, bays: parseInt(e.target.value, 10) || 1 })} data-testid="settings-bays-input" /></div>
            {DAYS.map((name, d) => (
              <div key={d} className="flex items-start gap-2 border-t pt-2" data-testid={`settings-day-${d}`}>
                <span className="w-24 text-sm font-semibold pt-1.5">{name}</span>
                <div className="flex-1 space-y-1">
                  {(s.hours[String(d)] || []).length === 0 && <p className="text-xs text-slate-400 pt-2">Fermé</p>}
                  {(s.hours[String(d)] || []).map((r, i) => (
                    <div key={i} className="flex items-center gap-1">
                      <Input type="time" className="h-8 w-28" value={r[0]} onChange={e => setRange(String(d), i, 0, e.target.value)} data-testid={`settings-${d}-${i}-start`} />–
                      <Input type="time" className="h-8 w-28" value={r[1]} onChange={e => setRange(String(d), i, 1, e.target.value)} data-testid={`settings-${d}-${i}-end`} />
                      <button type="button" onClick={() => del(String(d), i)} className="text-slate-400 hover:text-red-600"><Trash2 className="w-4 h-4" /></button>
                    </div>
                  ))}
                </div>
                <button type="button" onClick={() => add(String(d))} className="text-slate-500 hover:text-slate-900 pt-1.5" data-testid={`settings-add-${d}`}><Plus className="w-4 h-4" /></button>
              </div>
            ))}
            <p className="text-xs text-slate-500">L'intervalle entre deux plages correspond à la pause. Les absences validées des mécaniciens réduisent automatiquement la capacité du jour.</p>
            <Button className="w-full" onClick={save} data-testid="settings-save-btn">Enregistrer</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
